import React, { useState, useEffect } from 'react'
import MerchShopCard from 'components/Card/MerchShopCard'
import { getTimeDifference } from 'utils/helpers'

// components
import LoadingComponent from 'pages/explore/LoadingComponent'

//apis
import StoreAPI from 'apis/store'

// styles
import styles from './index.module.scss'

const CreatorMerchShop = props => {
  const { username, userAvatar, userId, isCreator } = props
  const [merchList, setMerchList] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [isVisibleFetching, setIsVisibleFetching] = useState(true)
  const [isFetching, setIsFetching] = useState(true)

  useEffect(() => {
    if (userId === undefined || userId === null) return
    StoreAPI.getStoreByUserId(userId, 1, 'all').then(
      res => {
        setIsVisibleFetching(false)
        let list = []
        let items = res['items']
        items.map(item => {
          if (
            item.deleted_at === null &&
            (item.sale_end_at === null || getTimeDifference(item.sale_end_at) > 0) &&
            (item.supply === null || item.supply - item.current_supply > 0)
          ) {
            if (item.master_edition_address === null) {
              list.push(item)
            } else {
              if (isCreator) {
                if (item.master_edition_address?.length === 0) list.push(item)
                else if (
                  item.master_edition_address?.length > 0 &&
                  (item.listed_master_edition.endTime === null ||
                    getTimeDifference(item.listed_master_edition.endTime) > 0)
                ) {
                  list.push(item)
                }
              } else {
                if (
                  item.master_edition_address?.length > 0 &&
                  (item.listed_master_edition.endTime === null ||
                    getTimeDifference(item.listed_master_edition.endTime) > 0)
                ) {
                  list.push(item)
                }
              }
            }
          }
        })
        setMerchList(list)
        setLoaded(true)
      },
      error => {
        setLoaded(true)
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, isCreator])

  return (
    <div className="w-full">
      {merchList.length > 0 ? (
        <div className="w-full grid xs:grid-cols-20 gap-[18px] md:gap-[22px] lg:gap-[22px] mt-[17px] lg:mt-[30px] z-10 sm:px-[7px] lg:px-[0px]">
          {merchList.map((item, index) => (
            <div className="xs:col-span-10 lg:col-span-5 2xl:col-span-4" key={item.id}>
              <MerchShopCard username={username} data={item} isCreator={isCreator} />
            </div>
          ))}
        </div>
      ) : loaded && !isVisibleFetching ? (
        <div className="w-full flex justify-center pt-[100px]">
          <div className={styles.noItem}>No merch items currently available.</div>
        </div>
      ) : (
        <></>
      )}
      {isVisibleFetching && (
        <div className="w-full h-[150px]">
          <LoadingComponent isFetching={isFetching} setIsFetching={setIsFetching} />
        </div>
      )}
    </div>
  )
}

export default CreatorMerchShop
